<div class="title">در صورت داشتن بیماری، مشخص کنید</div>
<div class="container">
  <app-radio-button
    *ngFor="let configButton of configButtons"
    [config]="configButton"
  ></app-radio-button>
</div>
